import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface PremiumBadgeProps {
  className?: string;
  showTooltip?: boolean;
  size?: "sm" | "md" | "lg";
}

/**
 * Premium badge component that displays a star icon for premium users.
 * Can optionally show a tooltip with "Premium Member" text.
 */
export function PremiumBadge({
  className,
  showTooltip = true,
  size = "sm",
}: PremiumBadgeProps) {
  const sizeClasses = {
    sm: "h-3.5 w-3.5",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };

  const badge = (
    <span
      className={cn(
        "inline-flex items-center justify-center text-adv-orange",
        className
      )}
      aria-label="Premium Member"
    >
      <Star className={cn(sizeClasses[size], "fill-current")} />
    </span>
  );

  if (!showTooltip) {
    return badge;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent>
          <p>Premium Member</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
